module.exports = __webpack_public_path__ + "images/wxwork/ic-wcwf-1@3x-ca789a9bebdf391ddb2c3e4a6a82d73b.png";